import latestSchema from './v2';

export default latestSchema;
